var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list-item',[_c('v-list-item-content',{on:{"click":function($event){return _vm.clieckedme(_vm.items.resource_id)}}},[_c('div',{staticClass:"item-content"},[_c('v-list-item-title',{staticClass:"list-item"},[_vm._v(" "+_vm._s(_vm.items.name))])],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }